module.exports = __webpack_public_path__ + "static/media/dpe1.png.9fc94718.jpg";